import { render } from "./NavPage.vue?vue&type=template&id=36d89a1c&scoped=true"
import script from "./NavPage.vue?vue&type=script&scoped=true&lang=js"
export * from "./NavPage.vue?vue&type=script&scoped=true&lang=js"

import "./NavPage.vue?vue&type=style&index=0&id=36d89a1c&scoped=true&lang=css"

import exportComponent from "/Users/salome/Desktop/salomeg5/epica/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d89a1c"]])

export default __exports__